module.exports = __webpack_public_path__ + "static/media/2DGACM2.8f08c982.jpg";